"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireDefault(require("reactstrap/lib/Modal"));

var _ModalBody = _interopRequireDefault(require("reactstrap/lib/ModalBody"));

var _ModalFooter = _interopRequireDefault(require("reactstrap/lib/ModalFooter"));

var _Row = _interopRequireDefault(require("reactstrap/lib/Row"));

var _Col = _interopRequireDefault(require("reactstrap/lib/Col"));

var _utils = require("../lib/utils");

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _modalUtils = require("../lib/modalUtils");

var _icons = require("../lib/icons");

var _icon = _interopRequireDefault(require("../icon/icon"));

require("./modal.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Modal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Modal);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onModalOpen", function () {
      var onOpened = _this.props.onOpened;
      (0, _modalUtils.handleIERenderingIssues)(_this.ref.current);

      if ((0, _utils.isFunction)(onOpened)) {
        onOpened();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderModal", function () {
      var _this$props = _this.props,
          header = _this$props.header,
          dataTestId = _this$props.dataTestId,
          stickToHeader = _this$props.stickToHeader,
          size = _this$props.size,
          backdrop = _this$props.backdrop,
          closeOnEscape = _this$props.closeOnEscape,
          titleAction = _this$props.titleAction,
          docUrl = _this$props.docUrl,
          docUrlTooltipText = _this$props.docUrlTooltipText,
          toggle = _this$props.toggle,
          body = _this$props.body,
          bodyClassName = _this$props.bodyClassName,
          footer = _this$props.footer;
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], (0, _extends2["default"])({
        "data-testid": dataTestId,
        innerRef: _this.ref,
        centered: !stickToHeader,
        fade: true,
        className: "oui-modal-dialog-scrollable",
        wrapClassName: (0, _utils.gatherClasses)(_this.props, "wrap-".concat(size)),
        modalClassName: (0, _utils.gatherClasses)(null, stickToHeader ? "oui-stick-to-header" : ""),
        backdrop: backdrop,
        keyboard: closeOnEscape
      }, (0, _utils.gatherConditionalProps)(_this.props, "isOpen", "size", "autoFocus", "toggle", "onClosed"), {
        onOpened: _this.onModalOpen
      }), header && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-modal-header"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-left"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-title"
      }, _this.getHeader()), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-actions"
      }, (0, _utils.isFunction)(titleAction) && titleAction())), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-right"
      }, docUrl && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        text: docUrlTooltipText || "",
        showToolTip: !!(0, _utils.isString)(docUrlTooltipText),
        placement: "bottom"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: docUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "oui-doc-url"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        src: _icons.Help,
        clickable: true
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "oui-close oui-ml-auto",
        "data-dismiss": "modal",
        "aria-label": "Close",
        onClick: toggle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")))), (0, _utils.isFunction)(body) && /*#__PURE__*/_react["default"].createElement(_ModalBody["default"], {
        className: (0, _utils.gatherClasses)(null, bodyClassName)
      }, body()), (0, _utils.isFunction)(footer) && /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, footer()));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderFullPageModal", function () {
      var _this$props2 = _this.props,
          dataTestId = _this$props2.dataTestId,
          backdrop = _this$props2.backdrop,
          closeOnEscape = _this$props2.closeOnEscape,
          header = _this$props2.header,
          titleAction = _this$props2.titleAction,
          docUrl = _this$props2.docUrl,
          docUrlTooltipText = _this$props2.docUrlTooltipText,
          toggle = _this$props2.toggle,
          body = _this$props2.body,
          bodyClassName = _this$props2.bodyClassName,
          footer = _this$props2.footer;
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], (0, _extends2["default"])({
        "data-testid": dataTestId,
        innerRef: _this.ref,
        fade: false,
        centered: false,
        wrapClassName: (0, _utils.gatherClasses)(_this.props, "wrap-xxl"),
        contentClassName: "modal-content-xxl",
        backdrop: backdrop,
        keyboard: closeOnEscape
      }, (0, _utils.gatherConditionalProps)(_this.props, "isOpen", "size", "autoFocus", "toggle", "onClosed"), {
        onOpened: _this.onModalOpen
      }), header && /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "oui-header-container"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        sm: {
          size: 8
        },
        className: "oui-mx-auto"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-left"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-title"
      }, _this.getHeader()), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-actions"
      }, (0, _utils.isFunction)(titleAction) && titleAction())), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-right"
      }, docUrl && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        text: docUrlTooltipText || "",
        showToolTip: !!(0, _utils.isString)(docUrlTooltipText),
        placement: "bottom"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: docUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "oui-doc-url"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        src: _icons.Help,
        clickable: true
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "oui-close oui-ml-auto",
        "data-dismiss": "modal",
        "aria-label": "Close",
        onClick: toggle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")))))), (0, _utils.isFunction)(body) && /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "oui-body-container"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        sm: {
          size: 8
        },
        className: "oui-body-inner-container oui-mx-auto"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(null, bodyClassName, "oui-body")
      }, body()))), (0, _utils.isFunction)(footer) && /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "oui-footer-container"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        sm: {
          size: 8
        },
        className: "oui-mx-auto"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-footer"
      }, footer()))));
    });
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "render",
    value: function render() {
      var size = this.props.size;
      return size === "xxl" ? this.renderFullPageModal() : this.renderModal();
    }
  }, {
    key: "getHeader",
    value: function getHeader() {
      var header = this.props.header;

      if ((0, _utils.isString)(header)) {
        return /*#__PURE__*/_react["default"].createElement(Modal.Header, {
          header: header
        });
      }

      if ((0, _utils.isFunction)(header)) {
        return header();
      }

      return null;
    }
  }]);
  return Modal;
}(_react["default"].Component);

Modal.propTypes = {
  isOpen: _propTypes["default"].bool,
  toggle: _propTypes["default"].func.isRequired,
  size: _propTypes["default"].oneOf(["sm", "md", "lg", "xl", "xxl"]),
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
  docUrl: _propTypes["default"].string,
  closeOnEscape: _propTypes["default"].bool,
  body: _propTypes["default"].func.isRequired,
  footer: _propTypes["default"].func,
  onOpened: _propTypes["default"].func,
  onClosed: _propTypes["default"].func,
  className: _propTypes["default"].string,
  bodyClassName: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  docUrlTooltipText: _propTypes["default"].string,
  stickToHeader: _propTypes["default"].bool,
  backdrop: _propTypes["default"].string,
  titleAction: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool
};
Modal.defaultProps = {
  isOpen: false,
  autoFocus: true,
  size: "md",
  closeOnEscape: true,
  backdrop: "static",
  bodyClassName: null,
  docUrl: null,
  dataTestId: "orion-modal"
};
Modal.displayName = "OrionModal";

Modal.Header = function MHeader(props) {
  var header = props.header;
  return /*#__PURE__*/_react["default"].createElement("h5", {
    className: (0, _utils.gatherClasses)(props, "oui-title")
  }, header);
};

Modal.Header.propTypes = {
  header: _propTypes["default"].string
};
Modal.Header.displayName = "OrionModalHeader";
Modal.Header.propTypes = {
  header: _propTypes["default"].string
};
Modal.Header.defaultProps = {
  header: ""
};
var _default = Modal;
exports["default"] = _default;